import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { Router } from 'react-router-dom';

import AppReducer from '../reducers';
import RootContainer from './RootContainer';
import Enhancers from '../utils/redux';
import history from '../utils/history';
import theme from '../styles/theme';


const appTheme = createMuiTheme(theme);

export const store = createStore(
  AppReducer,
  ...Enhancers,
);

export default class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={appTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Provider store={store}>
            <Router history={history}>
              <RootContainer />
            </Router>
          </Provider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App.js